import { render } from "./SheetMusic.vue?vue&type=template&id=1754156d&scoped=true"
import script from "./SheetMusic.vue?vue&type=script&lang=js"
export * from "./SheetMusic.vue?vue&type=script&lang=js"

import "./SheetMusic.vue?vue&type=style&index=0&id=1754156d&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1754156d"]])

export default __exports__